/**
 * Origem da API (VITE_API_URL sem o sufixo /api). Tira só o /api do FINAL:
 * um replace('/api', '') pegaria o "//api." de https://api.avancegestor.com.br.
 */
export const API_ORIGIN = (import.meta.env.VITE_API_URL || '').replace(/\/api\/?$/, '')

/**
 * Resolve a URL de exibição de um avatar/logo salvo em `avatar_url`/`logo_url`.
 * Aceita URL pública absoluta (Supabase Storage) ou, por compatibilidade com
 * registros antigos, um path relativo que era servido em `${API_BASE}/uploads/...`.
 * @param {string|null} url
 * @param {string} apiBase - import.meta.env.VITE_API_URL sem o sufixo /api
 * @returns {string|null}
 */
export function mediaUrl(url, apiBase) {
  if (!url) return null
  if (/^https?:\/\//i.test(url)) return url
  return `${apiBase}/uploads/${url}`
}
